import React from 'react'
import appTheme from '../appTheme'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@mui/material/styles'
import ErrorIcon from '@mui/icons-material/Report';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import { Grid, Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material";

const AlertDialog = (props) => {
    const {
      severity,
      onClose,
      message,
      // ⬆ filtering out props that `dialog` doesn’t know what to do with.
      ...rest
    } = props

    //console.log("Call AlertDialog - Message: ", message);

    function NewLineMessage(props) {
      return props.text.split('\\n').map((line, index) => <Box key={index} component='span'>{line}<br/></Box>)
    }
  
    let localMessage = message;

    return (
      <ThemeProvider theme={appTheme}>
      <Dialog
        {...rest} // `children` is just another prop!
        open={(localMessage.length > 0)}
        onClose={() => { onClose(); localMessage = ""; }}
      >
        <DialogContent>
          <Grid container direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
            <Grid item id="AlertIcon">
            {( !severity || severity === "info") && <InfoIcon fontSize="large" color='success'/>}
            {( severity === "warning") && <WarningIcon fontSize="large" color='secondary' />}
            {( severity === "error") && <ErrorIcon fontSize="large" color='error'/>}
            </Grid>
            <Grid item id="AlertMessage">
              <Typography
                style={{ whiteSpace: 'pre-line'}}
                sx={{
                  fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
                  color: 'common.black',
                }}>
              <NewLineMessage text={localMessage} />
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => { onClose(); localMessage = "";  }}>Sluiten</Button>
        </DialogActions>
      </Dialog>
      </ThemeProvider>
    )
}

AlertDialog.muiName = 'Dialog';
AlertDialog.propTypes = {
  children: PropTypes.node
};

export default AlertDialog
